import { BagelCodeBalanceProps } from './types';
import { StyledBagelCodeBalance } from './style';
import { formattingNumber } from '../../Helper/utils/utils';

const BagelCodeBalance = ({balance, balanceQuantityFormat}: BagelCodeBalanceProps) => {
    return (
        <StyledBagelCodeBalance>
            <img className="balanceImg" alt="balance" src={balance.image} />
            <span>{balanceQuantityFormat ?
                formattingNumber(
                    balance.amount,
                    balanceQuantityFormat,
                    false,
                    100,
                    false,
                    true
                ) :
                balance.amount
            }</span>
        </StyledBagelCodeBalance>
    )
}

export default BagelCodeBalance;
